import React from 'react';
import { useStaticQuery, graphql, Link } from 'gatsby';
import resolveUrl from '../../../utils/urls/resolve-url';
import * as b from "../../bootstrap.module.css";

const LocalfirmContents = ({ active }) => {
  const { articles } = useStaticQuery(graphql`
    query LocalfirmContents {
      articles: allMysqlBlog(
        filter: {blogTerms: {elemMatch: {term: {eq: "menu-posrednicy"}}}},
        limit: 6
      ) {
        nodes {
          title
          terms_path
          term_normalized
          url
          thumbnail_canvas
        }
      }
    }
  `);

  if (!active || !articles.nodes.length) {
    return null;
  }

  return (<>
    <strong>Artykuły o pośrednikach kredytowych</strong>

    <div className={['top-navigation-posts', b.mt2, b.pt1].join(' ')}>
      {articles.nodes.map((article, i) => (
        <Link key={i} to={resolveUrl(article.terms_path, article.term_normalized, article.url)}>
          <img src={article.thumbnail_canvas?.replace('/fa/', '/fk/')} className="top-navigation-thumbnail" loading="lazy" alt="" />
          
          <strong>{article.title}</strong>
        </Link>
      ))}
    </div> 
  </>);
};

export default LocalfirmContents;
